import _defineProperty from "/app/node_modules/.pnpm/next@13.4.17_@babel+core@7.14.3_@opentelemetry+api@1.4.1_react-dom@18.2.0_react@18.2.0_sass@1.49.9/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import { Component } from 'react';
import { FormattedMessage } from 'react-intl';
import { Text, Spacer } from '@vinted/web-ui';
import { SortByOption } from 'constants/filter';
import SelectableItemList from 'components/SelectableItemList';
import FilterDropdown from 'components/FilterDropdown';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

class SortFilter extends Component {
  constructor() {
    super(...arguments);

    _defineProperty(this, "translate", (id, values) => /*#__PURE__*/_jsx(FormattedMessage, {
      id: "user.items.filters.sort.".concat(id),
      values: values
    }));

    _defineProperty(this, "handleItemClick", item => {
      const {
        onItemClick
      } = this.props;
      onItemClick(item.value);
    });
  }

  renderDropdown() {
    const items = Object.values(SortByOption).map(option => ({
      id: option,
      title: this.translate("options.".concat(option)),
      value: option
    }));
    const {
      selected
    } = this.props;
    return /*#__PURE__*/_jsx("div", {
      className: "u-ui-padding-vertical-x-small",
      children: /*#__PURE__*/_jsx(SelectableItemList, {
        name: "sort_by",
        items: items,
        selected: [selected],
        onItemClick: this.handleItemClick
      })
    });
  }

  render() {
    return /*#__PURE__*/_jsxs("div", {
      className: "u-flexbox u-align-items-center",
      children: [/*#__PURE__*/_jsx(Text, {
        theme: "amplified",
        type: Text.Type.Subtitle,
        text: this.translate('name')
      }), /*#__PURE__*/_jsx(Spacer, {
        orientation: Spacer.Orientation.Vertical
      }), /*#__PURE__*/_jsx(FilterDropdown, {
        title: this.translate("options.".concat(this.props.selected)),
        placement: "bottom-end",
        closeOnClick: true,
        children: this.renderDropdown()
      })]
    });
  }

}

_defineProperty(SortFilter, "defaultProps", {
  selected: SortByOption.Relevance
});

export default SortFilter;